import { match } from 'ts-pattern'
import { ChargeSchedule } from '@/types'
import {
  convertKilometersToMiles,
  convertMilesToKilometers,
} from '@/utils/conversionUtilities'

type Unit = ChargeSchedule['battery_target_unit']

/**
 * A stored charge target as a battery percent. Schedules can keep the target
 * as a range in miles or kilometers, which converts through the car's miles
 * per percent (the same rule the dashboard's limit slider uses).
 */
export function targetToPercent(
  value: number,
  unit: Unit,
  milesPerPercent: number | null | undefined,
  fallback: number,
) {
  return match(unit)
    .with('percent', () => value)
    .with('miles', () =>
      milesPerPercent ? Math.round(value / milesPerPercent) : fallback,
    )
    .with('kilometers', () =>
      milesPerPercent
        ? Math.round(convertKilometersToMiles(value) / milesPerPercent)
        : fallback,
    )
    .exhaustive()
}

/** A battery percent written back in the schedule's own unit. */
export function percentToTarget(
  percent: number,
  unit: Unit,
  milesPerPercent: number | null | undefined,
) {
  return match(unit)
    .with('percent', () => Math.round(percent))
    .with('miles', () =>
      milesPerPercent ? Math.round(percent * milesPerPercent) : percent,
    )
    .with('kilometers', () =>
      milesPerPercent
        ? convertMilesToKilometers(percent * milesPerPercent)
        : percent,
    )
    .exhaustive()
}
